import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { borderRadius } from "@mui/system";

function InfoModalInfoLivro({ text, title }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      <Typography
        sx={{
          margin: 0,
          color: "var(--cor-preto)",
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          margin: 0,
          borderRadius: "0.5rem",
          width: "10.625rem",
          height: "2.188rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--cor-preto)",
          backgroundColor: "var(--cor-cinzaMargin)",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}

export default InfoModalInfoLivro;